// SPDX-License-Identifier: AGPL-3.0-or-later
export function toCents(dollars) {
    return Math.round(dollars * 100);
}
export function toDollars(cents) {
    return cents / 100;
}
export function sum(values) {
    let total = 0;
    for (const v of values)
        total += v;
    return total;
}
/**
 * Splits `total` into `parts` integer shares that add up exactly to `total`.
 * The first `|remainder|` shares get one extra cent (or one fewer when
 * `total` is negative).
 */
export function splitEvenly(total, parts) {
    if (parts <= 0)
        return [];
    const base = Math.trunc(total / parts);
    const remainder = total - base * parts;
    const step = Math.sign(remainder);
    return Array.from({ length: parts }, (_, i) => (i < Math.abs(remainder) ? base + step : base));
}
/**
 * Splits `total` in proportion to `weights`, using the largest-remainder
 * method so the shares add up exactly to `total`.
 */
export function splitByWeight(total, weights) {
    const weightSum = weights.reduce((a, b) => a + b, 0);
    if (weights.length === 0)
        return [];
    if (weightSum <= 0)
        return splitEvenly(total, weights.length);
    const exact = weights.map((w) => (total * w) / weightSum);
    const shares = exact.map((x) => Math.trunc(x));
    let leftover = total - sum(shares);
    const step = Math.sign(leftover);
    const order = exact
        .map((x, i) => ({ i, frac: Math.abs(x - Math.trunc(x)) }))
        .sort((a, b) => b.frac - a.frac || a.i - b.i);
    for (let k = 0; leftover !== 0; k = (k + 1) % order.length) {
        const entry = order[k];
        if (!entry)
            break;
        shares[entry.i] = (shares[entry.i] ?? 0) + step;
        leftover -= step;
    }
    return shares;
}
//# sourceMappingURL=money.js.map